import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import './LeadTag.styles.scss';

type LeadTagProps = {
  className?: string;
};

const LeadTag: React.FC<LeadTagProps> = (props) => {
  const { className } = props;

  const classes = classNames('lead-tag', className);

  const { t } = useTranslation();

  return <span className={classes}>{t('lead')}</span>;
};

export default LeadTag;
